<template>
  <pie-chart
    :width="width"
    :height="height"
    :chart-data="chartData"
    :options="options"
  />
</template>
<script>
import PieChart from '@/components/charts/PieChart'

export default {
  name: 'SalesBySubCategoryNameChart',
  components: {
    PieChart
  },
  props: {
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: undefined
    },
    salesBySubCategoryName: {
      type: Array,
      default: null
    },
    precision: { // 小数点第何位まで表示するか決める
      type: Number,
      default: 0
    }
  },
  computed: {
    chartData () {
      const total = this.salesBySubCategoryName.reduce((acc, cv) => {
        return acc + cv.sales
      }, 0)
      const percentages = this.salesBySubCategoryName.map(item => {
        const base = 10 ** this.precision
        return Math.round((item.sales / total * 100) * base) / base
      })
      return {
        datasets: [
          {
            type: 'pie',
            data: percentages,
            sales: this.salesBySubCategoryName.map(item => item.sales)
          }
        ],
        labels: this.salesBySubCategoryName.map(item => {
          if (item.subcategoryName === null) {
            return ''
          }
          return item.subcategoryName
        })
      }
    },
    options () {
      return {
        plugins: {
          legend: {
            position: 'right',
            labels: {
              boxWidth: 10,
              font: {
                size: 10
              },
              padding: 4
            },
            maxWidth: 200
          },
          tooltip: {
            callbacks: {
              label (tooltipItem) {
                const value = tooltipItem.formattedValue
                const sales = tooltipItem.dataset.sales[tooltipItem.dataIndex]
                return `\xA5${Number(sales).toLocaleString()} (${value}%)`
              }
            }
          },
          title: {
            display: true,
            text: 'サブカテゴリー'
          }
        },
        maintainAspectRatio: false
      }
    }
  }

}
</script>

<style scoped>
</style>
